import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal, getFormData } from '../../common';
import { QuizShowAdminRepository } from '../../repository/QuizShowAdminRepository';
import { NavBar } from './NavBar';

const repository = new QuizShowAdminRepository();

const QuizAdminGameListPage = (props) => {
  const [gameList, setGameList] = useState([]);
  const [user, setUser] = useState({});
  const [selectedGame, setSelectedGame] = useState({});
  const [qrcodeOpen, setQrcodeOpen] = useState(false);

  useEffect(() => {
    fetchMe();
    fetchGames();
  }, []);

  const fetchMe = () => {
    repository.findMe(null, (data) => {
      setUser(data);
    });
  };

  const fetchGames = () => {
    repository.searchGame(null, (data) => {
      setGameList(data.games);
    });
  };

  const onClickQRCode = (e) => {
    e.preventDefault();
    setQrcodeOpen(!qrcodeOpen);
  };

  const onSubmitGameCreate = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    repository.createGame(formData, () => {
      window.$("#game-list-game-create-modal").modal("hide");
      e.target.reset();
      fetchGames();
    });
  };

  const onClickGameUpdate = ({ gameId }) => {
    repository.findGame({ id: gameId }, (data) => {
      setSelectedGame(data);
      window.$("#game-list-game-update-modal").modal("show");
    });
  };

  const onClickGameDelete = ({ gameId }) => {
    repository.deleteGame({ id: gameId }, () => {
      fetchGames();
    });
  };

  const unload = (user.id === undefined);
  const loaded = !unload;
  const isLogin = (user.id !== null);

  return (
    <>
      <NavBar user={user} />

      <div className={"container"}>
        {loaded && isLogin && (
          <div style={{ marginTop: 30 }}>
            <button className={`btn btn-info`} onClick={onClickQRCode}>QRCode</button>
            &nbsp;<button
              className="btn btn-primary"
              data-toggle="modal"
              data-target="#game-list-game-create-modal">게임생성</button>
          </div>
        )}

        {loaded && !isLogin && (
          <div style={{ marginTop: 30 }}>
            <a href={"/oauth2/quizshow/google/login"}>
              <button className={"btn btn-danger"}>Google Login</button>
            </a>
          </div>
        )}

        {loaded && isLogin && (
          <div style={{ marginTop: 30 }}>
            <QuizAdminGameListGroup
              items={gameList}
              onClickUpdate={onClickGameUpdate}
              onClickDelete={onClickGameDelete}
              onChangeGameActive={() => fetchGames()} />
          </div>
        )}

        <Modal id={"game-list-game-create-modal"} title={"게임생성"}>
          <QuizAdminGameCreate onSubmit={onSubmitGameCreate} />
        </Modal>

        <Modal id={"game-list-game-update-modal"} title={"게임수정"}>
          <QuizAdminGameUpdate game={selectedGame} onSubmit={() => fetchGames()} />
        </Modal>

        {qrcodeOpen && (<QuizAdminGameQRWrap onClickClose={() => setQrcodeOpen(!qrcodeOpen)} />)}
      </div>
    </>
  );
};

const QuizAdminGameQRWrap = (props) => {
  useEffect(() => {
    const el = document.getElementById("qrcode");
    el.innerHTML = "";
    new window.QRCode(el, {
      text: "https://www.songnpark.com/quizshow",
      width: 480,
      height: 480
    });
  }, []);

  const onClickClose = (e) => {
    e.preventDefault();
    props.onClickClose && props.onClickClose();
  };

  return (
    <div style={{ display: "flex", position: "absolute", left: 0, right: 0, top: 0, bottom: 0, background: "#eee" }}>
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div id="qrcode" style={{ display: "inline-block" }}></div>
        </div>
      </div>
      <a href={"/"} style={{ position: "absolute", right: 10, top: 5 }} onClick={onClickClose}>
        <i className={"bi-x"} style={{ fontSize: 32, fontWeight: "bold" }}></i>
      </a>
    </div>
  );
};

const QuizAdminGameListGroup = (props) => {
  const { items } = props;

  const onClickDelete = (e) => {
    e.preventDefault();
    const { gameid } = e.target.dataset;
    const answer = window.confirm("Are you sure?");
    if (answer)
      props.onClickDelete && props.onClickDelete({ gameId: gameid });
  };

  const onClickUpdate = (e) => {
    e.preventDefault();
    const { gameid } = e.target.dataset;
    props.onClickUpdate && props.onClickUpdate({ gameId: gameid });
  };

  const onClickActivate = (e) => {
    e.preventDefault();
    const { gameid } = e.target.dataset;
    repository.activateGame({ id: gameid }, () => {
      props.onChangeGameActive && props.onChangeGameActive();
    });
  };

  const onClickDeactivate = (e) => {
    e.preventDefault();
    const { gameid } = e.target.dataset;
    repository.deactivateGame({ id: gameid }, () => {
      props.onChangeGameActive && props.onChangeGameActive();
    });
  };

  return (
    <>
      <table className={"table"}>
        <thead>
          <tr>
            <th style={{ width: "70%" }}>이름</th>
            <th style={{ width: "30%" }}></th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx}>
              <td>
                <Link to={`/quizshow-admin/${item.id}`}>{item.name}</Link>
                &nbsp;<button className={"btn btn-sm btn-outline-primary"} onClick={onClickUpdate} data-gameid={item.id}>변경</button>
                &nbsp;<button className={"btn btn-sm btn-outline-danger"} onClick={onClickDelete} data-gameid={item.id}>삭제</button>
              </td>
              <td>
                {item.activated && (
                  <button
                    data-gameid={item.id}
                    className={"btn btn-sm btn-primary"}
                    onClick={onClickDeactivate}>ACTIVE</button>)}
                {!item.activated && (
                  <button
                    data-gameid={item.id}
                    className={"btn btn-sm btn-light"}
                    onClick={onClickActivate}>ACTIVE</button>)}
                {item.activated && (
                  <span>
                    &nbsp;
                    <Link to={`/quizshow-admin/${item.id}/player`} className={"btn btn-sm btn-danger"}>PLAY</Link>
                  </span>)}
              </td>
            </tr>
          ))}
          {!items.length && (
            <tr><td colSpan={2}>NOT FOUND</td></tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const QuizAdminGameCreate = (props) => {
  return (
    <form onSubmit={props.onSubmit}>
      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>게임 이름</label>
        <input className={"form-control"} name={"name"} autoComplete={"off"} />
      </div>
      <br />
      <div className={"form-group"}>
        <input className={"form-control btn btn-primary"} type={"submit"} value={"생성하기"} />
      </div>
    </form>
  );
};

const QuizAdminGameUpdate = (props) => {
  const { game } = props;

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    repository.updateGame({ id: game.id, ...formData }, () => {
      window.$("#game-list-game-update-modal").modal("hide");
      setTimeout(() => e.target.reset(), 300);
      props.onSubmit && props.onSubmit();
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>게임 이름</label>
        <input className={"form-control"} name={"name"} autoComplete={"off"} defaultValue={game.name} />
      </div>
      <br />
      <div className={"form-group"}>
        <input className={"form-control btn btn-primary"} type={"submit"} value={"수정하기"} />
      </div>
    </form>
  );
};

export { QuizAdminGameListPage };
